import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowSplitRight"><Path d="M21 10H19.5V5.56055L13.0605 12L19.5 18.4395V14H21V21H14V19.5H18.4395L11.6895 12.75H3V11.25H11.6895L18.4395 4.5H14V3H21V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowSplitRight;
